// @/utils/i18n-validators.js
import * as validators from '@vuelidate/validators';

import { i18n } from '@/helpers/locale/locale.helper';

const { createI18nMessage } = validators;

const withI18nMessage = createI18nMessage({ t: i18n.global.t.bind(i18n) });

export const required = withI18nMessage(validators.required);

export const helpers = validators.helpers;

export const email = withI18nMessage(validators.email);

export const hexColor = helpers.withMessage(
  (value) => i18n.global.t('validations.hex_color', { property: value.$property }),
  helpers.regex(/^#(?:[0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/),
);

export const numeric = withI18nMessage(validators.numeric);

export const minValue = withI18nMessage(validators.minValue, { withArguments: true });

export const maxValue = withI18nMessage(validators.maxValue, { withArguments: true });

export const sameAs = withI18nMessage(validators.sameAs, { withArguments: true });

export const requiredIf = withI18nMessage(validators.requiredIf, { withArguments: true });

export const integer = withI18nMessage(validators.integer);

export const minLength = withI18nMessage(validators.minLength, { withArguments: true });

export const maxLength = withI18nMessage(validators.maxLength, { withArguments: true });

export const noSpecialChars = withI18nMessage(helpers.regex(/^[\p{L}\s0-9]+$/u));
